<!-- eslint-disable -->
<template>
    <div class="choix">
        <a href="#" @click="changeLanguage('en')" :class="{'disabled': $i18n.locale === 'en'}">English</a> | <a href="#" @click="changeLanguage('fr')" :class="{'disabled': $i18n.locale === 'fr'}">Francais</a>
    </div>
</template>

<script>
export default {
    // eslint-disable-next-line
    name : "language",
    methods : {
        changeLanguage(locale) {
            this.$i18n.locale = locale;
        },
    }
};
</script>

<style>
a{
    color: #62B22F !important;
}

.choix{
    text-align: right;
    margin-right: 5%;
    font-size: 1.25em;
    font-family: Lato;
    z-index: 1;
}

.disabled {
    color: #636363 !important; 
    pointer-events: none;
    text-decoration: none;
    cursor: not-allowed;
}
</style>